import axiosInstance from "../../services/axiosComman";

export const getNotifications = async () => {
  try {
    const response = await axiosInstance.get(
      // "/api/settings/notification/notifications/",
      "/notification/user",
    );
    return response.data;
  } catch (error) {
    console.log(error);
    return {
      count: 0,
      next: null,
      previous: null,
      results: [],
    };
  }
};

export const markAllNotificationsAsRead = async () => {
  try {
    const response = await axiosInstance.get(
      // "/api/settings/notification/notifications/mark_all_as_read/",
      "/notification/update/mark_all_as_read",
    );
    return response.data;
  } catch (error) {
    console.error("Error marking all notifications as read:", error);
    throw error;
  }
};

export const markNotificationAsRead = async (id) => {
  try {
    const response = await axiosInstance.put(
      // `/api/settings/notification/notifications/${id}/update_status/`,
      `/notification/update/is_read/${id}`,
      { is_read: true },
    );
    return response.data;
  } catch (error) {
    console.error(`Error marking notification ${id} as read:`, error);
    throw error;
  }
};

export const clearNotifications = async () => {
  try {
    const response = await axiosInstance.delete("/notification/delete");
    return response.data;
  } catch (error) {
    console.error("Error clearing notifications:", error);
    throw error;
  }
};

export const deleteNotification = async (id) => {
  try {
    const response = await axiosInstance.delete(`/notification/delete/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting notification ${id}:`, error);
    throw error;
  }
};
